<sl-titulo>Datos de la PAA</sl-titulo>

<usuario-paa [usuarioId]="usuarioId"></usuario-paa>
